module.exports = __webpack_public_path__ + "img/pr-4.78647c91.png";